import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db } from '../firebaseConfig'; 
import { doc, getDoc, setDoc, runTransaction } from 'firebase/firestore';
import { UIDS_CON_ACCESO_A_DEMO } from './Cupo';
import { useToast } from '../contexts/ToastContext';
const ConfirmationModal = ({ isOpen, title, onConfirm, onCancel, isProcessing }) => {
if (!isOpen) return null;
return (
<div className="modal-backdrop">
<div className="modal-content" style={{width:'600px'}}>
<h2 className="modal-title" style={{fontSize:'14px', margin:'0 auto 10px'}}>{title}</h2>
<p className="modal-message" style={{fontSize:'16px'}}>Esta acción es irreversible. Si confirma, usted perderá su posición en la lista de espera de Finca Los Astros y todos los beneficios asociados (degustaciones, prioridad en eventos, etc.).
<br className='spacer-10px'></br>Debido a la alta demanda de nuestro círculo, si desea volver a unirse en el futuro, deberá registrarse nuevamente al final de la lista.
</p>
<div className="modal-actions" style={{justifyContent:'center',margin:'0 auto', width:'90%', gap:'20px'}}>
<button
className="modal-button cancel"
style={{minWidth:'40%', fontSize:'13px'}}
onClick={onCancel}
disabled={isProcessing}
>
Cancelar
</button>
<button
className="modal-button confirm"
style={{minWidth:'50%', fontSize:'13px'}}
onClick={onConfirm}
disabled={isProcessing}
>
{isProcessing ? 'Confirmando...' : 'Confirmar y ceder mi lugar'}
</button>
</div>
</div>
</div>
);
};
const formatDomicilio = (data) => {
let domicilio = '';
if (data.calle) {
domicilio += data.calle || '';
}
if (data.altura) {
domicilio += (domicilio ? ' ' : '') + (data.altura || '');
}
if (data.piso) {
domicilio += (domicilio ? ', ' : '') + `Piso: ${data.piso}`;
}
if (data.unidad) {
domicilio += (domicilio ? ', ' : '') + `Unidad: ${data.unidad}`;
}
return domicilio; 
};
function Perfil() {
const { user, loading: authLoading } = useAuth();
const { showToast } = useToast();
const [userData, setUserData] = useState(null);
const [loadingData, setLoadingData] = useState(true);
const [error, setError] = useState(null);
const [comunicacionesChecked, setComunicacionesChecked] = useState(false);
const [savingComms, setSavingComms] = useState(false);
const [isEditing, setIsEditing] = useState(false);
const [editFormData, setEditFormData] = useState({});
const [isSaving, setIsSaving] = useState(false);
const [isSubmittingList, setIsSubmittingList] = useState(false);
const [isClientInActiveList, setIsClientInActiveList] = useState(false);
const [listCheckLoading, setListCheckLoading] = useState(true);
const [isModalOpen, setIsModalOpen] = useState(false);
const [dateInput, setDateInput] = useState('');
const [isDateValid, setIsDateValid] = useState(true);
const isValidDateString = (dateString) => {
if (!/^\d{2}\/\d{2}\/\d{4}$/.test(dateString)) return false;
const parts = dateString.split('/');
const day = parseInt(parts[0], 10);
const month = parseInt(parts[1], 10);
const year = parseInt(parts[2], 10);
const date = new Date(year, month - 1, day);
if (date.getFullYear() !== year || date.getMonth() + 1 !== month || date.getDate() !== day) return false;
return true;
};
const calculateAgeFromDDMMYYYY = (dateString) => {
if (!isValidDateString(dateString)) return 0;
const parts = dateString.split('/');
const yyyyMmDd = `${parts[2]}-${parts[1]}-${parts[0]}`; 
const birthDate = new Date(yyyyMmDd);
const today = new Date();
let age = today.getFullYear() - birthDate.getFullYear();
const monthDifference = today.getMonth() - birthDate.getMonth();
if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
age--;
}
return age;
};
const convertToBackendFormat = (ddMmYyyy) => {
if (!ddMmYyyy || !isValidDateString(ddMmYyyy)) return '';
const parts = ddMmYyyy.split('/');
return `${parts[2]}-${parts[1]}-${parts[0]}`;
};
useEffect(() => {
if (authLoading || !user) {
if (!authLoading && !user) {
setError("Debe iniciar sesión para ver su perfil.");
setLoadingData(false);
}
return;
}
const fetchUserData = async () => {
try {
let data = null;
let docSnap;
let docRef = doc(db, 'clientes', user.uid);
docSnap = await getDoc(docRef);
if (docSnap.exists()) {
data = docSnap.data();
} else {
console.log("No encontrado en 'clientes'. Buscando en 'usuarios'...");
docRef = doc(db, 'usuarios', user.uid);
docSnap = await getDoc(docRef);
if (docSnap.exists()) {
data = docSnap.data();
}
}
if (data) {
setUserData(data);
setComunicacionesChecked(!!data.comunicaciones); 
} else {
setError("No se encontraron sus datos de perfil.");
}
} catch (err) {
console.error("Error al cargar los datos de Firestore:", err);
setError("Hubo un error al cargar sus datos. Inténtelo más tarde.");
} finally {
setLoadingData(false);
}
};
fetchUserData();
}, [user, authLoading]);
useEffect(() => {
const checkListStatus = async () => {
if (!user || !user.uid) {
setListCheckLoading(false);
return;
}
try {
const listRef = doc(db, 'lista', 'estado_clientes');
const docSnap = await getDoc(listRef);
if (docSnap.exists()) {
const listData = docSnap.data();
const activa = listData.activa || [];
const isInActive = activa.includes(user.uid);
setIsClientInActiveList(isInActive);
} else {
console.warn("El documento 'estado_clientes' no existe.");
}
} catch (err) {
console.error("Error al verificar el estado de la lista:", err);
} finally {
setListCheckLoading(false);
}
};
if (!authLoading && user) {
checkListStatus();
}
}, [user, authLoading]);
const handleOpenCederModal = () => {
setError(null);
setIsModalOpen(true);
};
const handleCloseCederModal = () => {
setIsModalOpen(false);
};
const esEmpleadoConAcceso = UIDS_CON_ACCESO_A_DEMO.includes(user?.uid);
const handleConfirmCederLugarEmpleado = async () => {
// Empleados: no ocupan un lugar real en lista/estado_clientes.activa[]
// (ver backend/main.py, _sumar_a_lista_de_espera), así que "ceder el
// lugar" acá es solo cosmético: vuelven a 'Registrado' sin transacción
// ni rotación de la fila real.
if (!user || !user.uid) {
setError("Error: Usuario no identificado.");
handleCloseCederModal();
return;
}
setIsSubmittingList(true);
setError(null);
try {
const clientRef = doc(db, 'clientes', user.uid);
await setDoc(clientRef, { estadoLista: 'Registrado', cupos_vinos: [] }, { merge: true });
setUserData(prevData => ({
...prevData,
estadoLista: 'Registrado',
cupos_vinos: []
}));
showToast("Listo. Cediste tu lugar en la lista.", 'success');
// Recarga completa: AuthContext solo trae el perfil una vez, así que sin
// esto el navbar/perfil seguirían mostrando el estado viejo.
setTimeout(() => window.location.reload(), 1200);
} catch (err) {
console.error("Error al ceder el lugar (empleado):", err);
setError("Hubo un error al ceder su lugar. Inténtelo más tarde.");
} finally {
setIsSubmittingList(false);
handleCloseCederModal();
}
};
const handleConfirmCederLugar = async () => {
if (!user || !user.uid) {
setError("Error: Usuario no identificado.");
handleCloseCederModal();
return;
}
const userId = user.uid;
setIsSubmittingList(true);
setError(null);
const listRef = doc(db, 'lista', 'estado_clientes');
const clientRef = doc(db, 'clientes', userId);
try {
await runTransaction(db, async (transaction) => {
const listSnap = await transaction.get(listRef);
if (!listSnap.exists()) {
throw new Error("Documento de lista no encontrado. Verifique la colección 'lista' y el documento 'estado_clientes'.");
}
const oldClientSnap = await transaction.get(clientRef);
const cuposToTransfer = oldClientSnap.data()?.cupos_vinos || [];
const currentList = listSnap.data();
let activa = [...(currentList.activa || [])];
let espera = [...(currentList.espera || [])];
const activeIndex = activa.indexOf(userId);
if (activeIndex === -1) {
throw new Error("Usted no se encuentra en la lista activa para ceder su lugar.");
}
activa.splice(activeIndex, 1);
espera.push(userId);
let newMemberId = null;
if (espera.length > 1) {
newMemberId = espera.shift();
activa.push(newMemberId);
console.log(`Rotación: ${newMemberId} pasa a activa. ${userId} pasa a espera.`);
const newClientRef = doc(db, 'clientes', newMemberId);
transaction.update(newClientRef, {
estadoLista: 'Activo',
cupos_vinos: cuposToTransfer
});
} else {
console.log(`Rotación: No hay miembros en espera para mover a activa (solo queda el ID cedido).`);
}
transaction.update(clientRef, {
estadoLista: 'Espera',
cupos_vinos: []
});
transaction.update(listRef, {
activa: activa,
espera: espera
});
});
setUserData(prevData => ({
...prevData,
estadoLista: 'Espera',
cupos_vinos: []
}));
showToast("¡Lugar cedido con éxito! Su ID ha sido movido al final de la lista de espera, y la lista activa se ha actualizado.", 'success');
setIsClientInActiveList(false);
setTimeout(() => window.location.reload(), 1200);
} catch (err) {
console.error("Error al ceder el lugar en la lista (Transacción):", err);
if (err.message && err.message.includes("Usted no se encuentra")) {
setError(err.message);
setIsClientInActiveList(false);
} else if (err.message && err.message.includes("Documento de lista no encontrado")) {
setError("Error de configuración de la lista. Contacte a soporte.");
} else {
setError("Hubo un error al ceder su lugar. Inténtelo más tarde.");
}
} finally {
setIsSubmittingList(false);
handleCloseCederModal();
}
};
const startEditing = () => {
setError(null);
const backendDate = userData?.fechaDeNacimiento || '';
let initialDateInput = '';
if (backendDate) {
const parts = backendDate.split('-');
if (parts.length === 3) {
initialDateInput = `${parts[2]}/${parts[1]}/${parts[0]}`;
}
}
setDateInput(initialDateInput); 
setIsDateValid(true);
setEditFormData({
nombre: userData?.nombre || '',
apellido: userData?.apellido || '',
fechaDeNacimiento: initialDateInput, 
titulo: userData?.titulo || '',
empresa: userData?.empresa || '',
calle: userData?.calle || '',
altura: userData?.altura || '',
piso: userData?.piso || '',
unidad: userData?.unidad || '',
ciudad: userData?.ciudad || '',
codigoPostal: userData?.codigoPostal || '',
pais: userData?.pais || '',
});
setIsEditing(true);
};
const handleFormChange = (e) => {
const { name, value } = e.target;
setEditFormData(prevData => ({
...prevData,
[name]: value
}));
};
const handleDateChange = (e) => {
let value = e.target.value.replace(/[^\d]/g, '');
const name = e.target.name;
if (value.length > 2 && value.length <= 4) {
value = `${value.slice(0, 2)}/${value.slice(2)}`;
} else if (value.length > 4) {
value = `${value.slice(0, 2)}/${value.slice(2, 4)}/${value.slice(4, 8)}`;
}
setDateInput(value);
if (value.length === 10) {
const valid = isValidDateString(value) && calculateAgeFromDDMMYYYY(value) >= 18;
setIsDateValid(valid);
if (!valid) {
setError(isValidDateString(value) ? "Debe ser mayor de 18 años para registrarse." : "La fecha de nacimiento no es válida (DD/MM/YYYY).");
} else {
setError(null);
}
} else {
setIsDateValid(true);
}
setEditFormData(prevData => ({
...prevData,
[name]: value
}));
};
const handleSave = async () => {
if (!user || !user.uid) return;
// Staff-preview es solo lectura: nunca crear un doc en 'clientes' para un empleado.
if (user.profileData?.isStaff) return;
setIsSaving(true);
setError(null);
setIsDateValid(true);
const fechaNacimientoDDMMYYYY = dateInput; 
const requiredAge = 18;
if (!fechaNacimientoDDMMYYYY || fechaNacimientoDDMMYYYY.trim().length !== 10 || !isValidDateString(fechaNacimientoDDMMYYYY)) {
setError("La fecha de nacimiento es obligatoria, debe estar completa y ser válida (DD/MM/YYYY).");
setIsDateValid(false); 
setIsSaving(false);
return;
}
const edad = calculateAgeFromDDMMYYYY(fechaNacimientoDDMMYYYY);
if (edad < requiredAge) {
setError(`Debe ser mayor de ${requiredAge} años para registrarse.`);
setIsDateValid(false); 
setIsSaving(false);
return;
}
const fechaNacimientoBackend = convertToBackendFormat(fechaNacimientoDDMMYYYY); 
const dataToUpdate = {
nombre: editFormData.nombre.trim() || '',
apellido: editFormData.apellido.trim() || '',
fechaDeNacimiento: fechaNacimientoBackend,
titulo: editFormData.titulo.trim() || '',
empresa: editFormData.empresa.trim() || '',
calle: editFormData.calle.trim() || '',
altura: editFormData.altura.trim() || '',
piso: editFormData.piso.trim() || '',
unidad: editFormData.unidad.trim() || '',
ciudad: editFormData.ciudad.trim() || '',
codigoPostal: editFormData.codigoPostal.trim() || '',
pais: editFormData.pais.trim() || '',
};
try {
const docRef = doc(db, 'clientes', user.uid);
await setDoc(docRef, dataToUpdate, { merge: true });
setUserData(prevData => ({
...prevData,
...dataToUpdate
}));
setIsEditing(false);
console.log("Datos de perfil actualizados con éxito.");
} catch (err) {
console.error("Error al actualizar los datos de perfil:", err);
setError("No se pudo guardar la información del perfil. Inténtelo de nuevo.");
} finally {
setIsSaving(false);
}
};
const handleComunicacionesChange = async (e) => {
const isChecked = e.target.checked;
setSavingComms(true);
setComunicacionesChecked(isChecked); 
try {
const docRef = doc(db, 'clientes', user.uid);
await setDoc(docRef, {
comunicaciones: isChecked
}, { merge: true });
console.log("Comunicaciones actualizadas a:", isChecked);
} catch (err) {
console.error("Error al actualizar comunicaciones:", err);
setError("No se pudo guardar la preferencia de comunicaciones. Inténtelo de nuevo.");
setComunicacionesChecked(!isChecked); 
} finally {
setSavingComms(false);
}
};
if (loadingData || authLoading) {
return null;
}
if (error && !isEditing) {
return <div className="perfil-error">{error}</div>;
}
const domicilio = userData ? formatDomicilio(userData) : '';
const emailPresidencia = "mgallo@fincalosastros.com"; 
const displayFields = [
{ label: 'Nombre:', value: userData?.nombre || '', name: 'nombre', editable: true },
{ label: 'Apellido:', value: userData?.apellido || '', name: 'apellido', editable: true },
{ label: 'Título:', value: userData?.titulo || '', name: 'titulo', editable: true },
{ label: 'Empresa:', value: userData?.empresa || '', name: 'empresa', editable: true },
{ label: 'Domicilio:', value: domicilio, name: 'domicilio', editable: false },
{ label: 'Ciudad:', value: userData?.ciudad || '', name: 'ciudad', editable: true },
{ label: 'Código Postal:', value: userData?.codigoPostal || '', name: 'codigoPostal', editable: true },
{ label: 'País:', value: userData?.pais || '', name: 'pais', editable: true },
{ label: 'E-mail:', value: user.email || '', name: 'email', editable: false },
];
const visibleFields = displayFields.filter(field => field.value.trim() !== '' || isEditing);
return (
<div className="perfil-container">
<ConfirmationModal
isOpen={isModalOpen}
title="¿ESTÁ SEGURO QUE DESEA CEDER SU LUGAR?"
onConfirm={esEmpleadoConAcceso ? handleConfirmCederLugarEmpleado : handleConfirmCederLugar}
onCancel={handleCloseCederModal}
isProcessing={isSubmittingList}
/>
<div className="perfil-grid">
{}
<div className="perfil-columna columna-datos">
<h2 className="perfil-titulo-columna">Sus Datos Personales</h2>
{isEditing ? (
<div className="perfil-datos-lista editar">
{}
{displayFields.filter(f => f.editable && f.name !== 'domicilio').map((field) => (
<div key={field.name} className="perfil-dato-item">
<label className="dato-etiqueta" htmlFor={field.name}>{field.label}</label>
<input
id={field.name}
name={field.name}
type="text"
className="dato-input"
value={editFormData[field.name]}
onChange={handleFormChange}
disabled={isSaving}
/>
</div>
))}
{}
<div key="fechaDeNacimiento" className="perfil-dato-item">
<label className="dato-etiqueta" htmlFor="fechaDeNacimiento">Fecha de Nacimiento:</label>
<input
id="fechaDeNacimiento"
name="fechaDeNacimiento"
type="text"
placeholder="DD/MM/YYYY"
maxLength="10"
className="dato-input"
style={!isDateValid ? {borderColor: 'red', borderWidth: '1px',textAlign:'center'} : {textAlign:'center'}}
value={dateInput}
onChange={handleDateChange}
disabled={isSaving}
/>
</div>
{}
{[
{ label: 'Calle:', name: 'calle' },
{ label: 'Altura:', name: 'altura', type: 'number' },
{ label: 'Piso:', name: 'piso' },
{ label: 'Unidad:', name: 'unidad' },
].map((field) => (
<div key={field.name} className="perfil-dato-item">
<label className="dato-etiqueta" htmlFor={field.name}>{field.label}</label>
<input
id={field.name}
name={field.name}
type={field.type || 'text'}
className="dato-input"
value={editFormData[field.name]}
onChange={handleFormChange}
disabled={isSaving}
/>
</div>
))}
<div style={{width:'100%', display:'flex', justifyContent:'right', alignItems:'right', borderTop:'1px solid #a58d70',marginTop:'15px', paddingTop:'15px'}}>
<button className="add-to-cart-button"
onClick={handleSave} 
disabled={isSaving || !isDateValid}
style={{margin:'0  0 0 auto'}}
> Guardar
</button></div>
</div>
) : (
<div className="perfil-datos-lista">
{visibleFields.map((field) => (
<div key={field.label} className="perfil-dato-item">
<span className="dato-etiqueta">{field.label}</span>
<span className="dato-valor">{field.value}</span>
</div>
))}
{visibleFields.length === 0 && (
<p className="contenido-centrado" style={{color: '#888'}}>
No hay datos cargados en su perfil.
</p>
)}
</div>
)}{!isEditing && !user?.profileData?.isStaff && (
<div style={{width:'100%', display:'flex', justifyContent:'right', alignItems:'right', borderTop:'1px solid #a58d70',marginTop:'15px', paddingTop:'15px'}}>
<button className="add-to-cart-button"
onClick={startEditing}
style={{margin:'0  0 0 auto'}}
> Modificar
</button></div>
)}
</div>
{}
<div className="perfil-columna columna-contacto">
<div className="perfil-seccion-comunicaciones">
<h2 className="perfil-titulo-columna">Comunicaciones</h2>
<label className="checkbox-container">
<input
type="checkbox"
checked={comunicacionesChecked}
onChange={handleComunicacionesChange}
disabled={savingComms}
/>
<span className="checkbox-checkmark"></span>
<span className="checkbox-label-text">
Acepto recibir comunicaciones de Finca Los Astros. Al marcar esta casilla, recibirá por correo electrónico novedades sobre invitaciones a catas privadas, acceso anticipado a lanzamientos, acceso a preventas e invitaciones a eventos. Podrá desuscribirse en cualquier momento.
</span>
</label>
</div>
<h2 className="perfil-titulo-columna" style={{margin:'30px 0 0'}}>Contacto Directo con Presidencia</h2>
<p className="perfil-texto-contacto">
Su opinión como miembro de nuestro círculo es de máximo valor para la dirección de Finca Los Astros. Para asegurar que su voz sea escuchada y atender asuntos particulares, habilitamos una línea de comunicación directa. Para cualquier sugerencia estratégica, inquietud o comentario que considere relevante, puede escribirme a la siguiente dirección. Me encargaré de revisar su mensaje personalmente:
</p>
<a 
href={`mailto:${emailPresidencia}`} 
className="perfil-email-presidencia"
>
{emailPresidencia}
</a>
{listCheckLoading ? (
<p className="contenido-centrado" style={{marginTop:'30px', color: '#888'}}>
Cargando estado de lista...
</p>
) : (
(esEmpleadoConAcceso
    ? userData?.estadoLista !== 'Registrado'
    // Empleados: el botón depende solo de estadoLista, nunca del array real
    // lista/estado_clientes.activa[] (no deberían estar ahí nunca, ver
    // backend/main.py _sumar_a_lista_de_espera). Clientes reales sí usan
    // isClientInActiveList, que refleja ese array de verdad.
    : isClientInActiveList
) && (
<div style={{width:'100%', marginTop:'30px', borderTop:'1px solid #a58d70', paddingTop:'20px', display:'flex', }}>
<button
className="ceder-button"
onClick={handleOpenCederModal} 
disabled={isSubmittingList}
>
{isSubmittingList ? 'Cediendo lugar...' : 'Ceder mi lugar en la lista'}
</button>
</div>
)
)}
</div>
</div>
</div>
);
}
export default Perfil;